import { Record, List } from "immutable";

import { FileAPIAccepted } from "@typings/fileUploading";

export interface ApplyState {
  form: Record<ApplyForm>;
  accessToken: string | null;
  isFormDataPrefetched: boolean;
  isTokenInvalid: boolean;
  isLocalStorageChecked: boolean;
}

export interface ApplyForm
  extends ApplyFormPersonalInfo,
    ApplyFormExperienceInfo {
  email: string | null;
}

export interface ApplyFormPersonalInfo {
  title: string;
  firstName: string;
  lastName: string;
  phoneNumberPrefix: string;
  phoneNumber: string;
  streetAddress: string;
  zipCode: string;
  city: string;
}

export interface ApplyFormExperienceInfo {
  workPermitType: AvailableWorkPermitTypes | null;
  hoursPerWeek: AvailableWorkHours | null;
  yearsOfExperience: YEARS_OF_EXPERIENCE | null;
  sourcesOfExperience: List<SOURCES_OF_EXPERIENCE>;
  methodOfCommuting: COMMUTING | null;
  files: List<FileAPIAccepted>;
  howDidYouHearAboutUs: List<INFO_SOURCE>;
}

// Client
export enum WORK_PERMIT_TYPE {
  IS_SWISS = "IS_SWISS",
  PERMIT_C = "PERMIT_C",
  PERMIT_B = "PERMIT_B",
  PERMIT_L = "PERMIT_L",
  PERMIT_F = "PERMIT_F",
  PERMIT_G = "PERMIT_G",
  PERMIT_N = "PERMIT_N",
  PERMIT_S = "PERMIT_S",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  MORE_THAN_THIRTY = "MORE_THAN_THIRTY",
}

export enum INFO_SOURCE {
  GOOGLE = "GOOGLE",
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  LINKEDIN = "LINKEDIN",
  FRIENDS_OR_FAMILY = "FRIENDS_OR_FAMILY",
  TV = "TV",
  RADIO = "RADIO",
  EVENT = "EVENT",
  BILLBOARD = "BILLBOARD",
  NEWS_ARTICLE = "NEWS_ARTICLE",
  ONLINE_JOB_AD = "ONLINE_JOB_AD",
  TALENT_COM = "TALENT_COM",
  OTHER = "OTHER",
}

// ^^

// France
export enum WORK_PERMIT_TYPE_FR {
  IS_FRENCH = "IS_FRENCH",
  EU_CITIZENSHIP = "EU_CITIZENSHIP",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_FR {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_THIRTY_FIVE = "THIRTY_ONE_TO_THIRTY_FIVE",
}
// ^^

// Poland
export enum WORK_PERMIT_TYPE_PL {
  IS_POLISH = "IS_POLISH",
  EU_CITIZENSHIP = "EU_CITIZENSHIP",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  NO_PERMIT_PL_FOREIGNER = "NO_PERMIT_PL_FOREIGNER",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_PL {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_AND_MORE = "THIRTY_ONE_AND_MORE",
}
// ^^

// Germany
export enum WORK_PERMIT_TYPE_DE {
  IS_GERMAN = "IS_GERMAN",
  EU_CITIZENSHIP = "EU_CITIZENSHIP",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_DE {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_FOURTY = "THIRTY_ONE_TO_FOURTY",
}
// ^^

// Italy
export enum WORK_PERMIT_TYPE_IT {
  IS_ITALIAN = "IS_ITALIAN",
  EU_CITIZENSHIP = "EU_CITIZENSHIP",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_IT {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_FOURTY = "THIRTY_ONE_TO_FOURTY",
}
// ^^

// Austria
export enum WORK_PERMIT_TYPE_AT {
  IS_AUSTRIAN = "IS_AUSTRIAN",
  EU_CITIZENSHIP = "EU_CITIZENSHIP",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_AT {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_FOURTY = "THIRTY_ONE_TO_FOURTY",
}
// ^^

// Belgium
export enum WORK_PERMIT_TYPE_BE {
  IS_BELGIAN = "IS_BELGIAN",
  ELECTRONICAL_A_CARD = "ELECTRONICAL_A_CARD",
  ELECTRONICAL_B_CARD = "ELECTRONICAL_B_CARD",
  ELECTRONICAL_C_CARD = "ELECTRONICAL_C_CARD",
  ELECTRONICAL_D_CARD = "ELECTRONICAL_D_CARD",
  ELECTRONICAL_EU_CARD = "ELECTRONICAL_EU_CARD",
  ELECTRONICAL_EU_PLUS_CARD = "ELECTRONICAL_EU_PLUS_CARD",
  ELECTRONICAL_F_CARD = "ELECTRONICAL_F_CARD",
  ELECTRONICAL_F_PLUS_CARD = "ELECTRONICAL_F_PLUS_CARD",
  ELECTRONICAL_H_CARD = "ELECTRONICAL_H_CARD",
  ELECTRONICAL_M_CARD = "ELECTRONICAL_M_CARD",
  ELECTRONICAL_M_CARD_WITH_FIXED_STAY_MENTIONNED = "ELECTRONICAL_M_CARD_WITH_FIXED_STAY_MENTIONNED",
  ELECTRONICAL_N_CARD = "ELECTRONICAL_N_CARD",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_BE {
  TEN_TO_FIFTEEN = "TEN_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_THIRTY_SEVEN = "THIRTY_ONE_TO_THIRTY_SEVEN",
}
// ^^

// Netherlands
export enum WORK_PERMIT_TYPE_NL {
  IS_DUTCH = "IS_DUTCH",
  EU_CITIZENSHIP = "EU_CITIZENSHIP",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_NL {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_FOURTY = "THIRTY_ONE_TO_FOURTY",
}
// ^^

// UK
export enum WORK_PERMIT_TYPE_UK {
  IS_BRITISH = "IS_BRITISH",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_UK {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_FOURTY = "THIRTY_ONE_TO_FOURTY",
}
// ^^

// US
export enum WORK_PERMIT_TYPE_US {
  IS_AMERICAN = "IS_AMERICAN",
  RESIDENCE_CARD = "RESIDENCE_CARD",
  VISA = "VISA",
  NO_PERMIT = "NO_PERMIT",
}

export enum HOURS_PER_WEEK_US {
  FIVE_TO_FIFTEEN = "FIVE_TO_FIFTEEN",
  FIFTEEN_TO_THIRTY = "FIFTEEN_TO_THIRTY",
  THIRTY_ONE_TO_FOURTY = "THIRTY_ONE_TO_FOURTY",
}
// ^^

export enum YEARS_OF_EXPERIENCE {
  NONE = "NONE",
  TWO_OR_LESS = "TWO_OR_LESS",
  MORE_THAN_TWO = "MORE_THAN_TWO",
  MORE_THAN_FIVE = "MORE_THAN_FIVE",
}

export enum SOURCES_OF_EXPERIENCE {
  CLEANING_HOUSES = "CLEANING_HOUSES",
  CLEANING_OFFICES = "CLEANING_OFFICES",
  CLEANING_HOTELS = "CLEANING_HOTELS",
  CLEANING_CLINICAL = "CLEANING_CLINICAL",
}

export enum COMMUTING {
  CAR = "CAR",
  SCOOTER = "SCOOTER",
  BIKE = "BIKE",
  NONE = "NONE",
}

export enum TITLE_OPTS {
  MR = "MR",
  MS = "MS",
}

export type ApplyReducer = Record<ApplyState>;

export type AvailableWorkHours =
  | HOURS_PER_WEEK
  | HOURS_PER_WEEK_FR
  | HOURS_PER_WEEK_PL
  | HOURS_PER_WEEK_DE
  | HOURS_PER_WEEK_IT
  | HOURS_PER_WEEK_AT
  | HOURS_PER_WEEK_BE
  | HOURS_PER_WEEK_NL
  | HOURS_PER_WEEK_UK
  | HOURS_PER_WEEK_US;

export type AvailableWorkPermitTypes =
  | WORK_PERMIT_TYPE
  | WORK_PERMIT_TYPE_AT
  | WORK_PERMIT_TYPE_BE
  | WORK_PERMIT_TYPE_DE
  | WORK_PERMIT_TYPE_FR
  | WORK_PERMIT_TYPE_IT
  | WORK_PERMIT_TYPE_NL
  | WORK_PERMIT_TYPE_PL
  | WORK_PERMIT_TYPE_UK
  | WORK_PERMIT_TYPE_US;

export const LOCAL_STORAGE_KEY = "store:apply";
